import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import IntegrationMarketModal from "../Modal/IntegrationMarketModal";
import CustomSelect from "../../../common/CustomSelect/CustomSelect";
import Backdrop from "../../../UI/Backdrop/Backdrop";

import {
  RequestSetConfig,
  RequestDeleteConfig,
  RequestUpdateConfig,
  RequestTapInterfaces,
} from "../../../../store/actions/integrationsActions";
import { addNotification } from "../../../../store/actions/notifierActions";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TapInterfaceSettings = ({ show, setShow, dataTmp = 0, setActiveInt }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [confType, setConfType] = useState(false);
  const [hoverBack, setHoverBack] = useState(false);
  const [selectedTapInterface, setSelectedTapInterface] = useState(null);

  const getConfig = useSelector((state) => state.integrations.getConfig);
  const setConfig = useSelector((state) => state.integrations.setConfig);
  const deleteConfig = useSelector((state) => state.integrations.deleteConfig);
  const loadingUpdate = useSelector((state) => state.integrations.loadingUpdate);
  const loading = useSelector((state) => state.integrations.loading);
  const tapInterfaces = useSelector((state) => state.integrations.tapInterfaces);
  const tapInterfacesLoading = useSelector((state) => state.integrations.tapInterfacesLoading);

  let query = useQuery();
  let confTmp = parseInt(dataTmp);

  const closePopupHandler = () => {
    cleanData();
    setShow(false);
    setActiveInt("");
    history.push("/integration-market");
  };

  const cleanData = () => {};

  useEffect(() => {
    dispatch(RequestTapInterfaces());
  }, [dispatch]);

  useEffect(() => {
    if (query.get("t") === "add") {
      setConfType(true);
    } else if (query.get("t") === null) {
      setHoverBack(false);
      cleanData();
    } else {
      setConfType(false);
    }
  }, [query]);

  useEffect(() => {
    if (deleteConfig === "Success" && query.get("conf") === "tapweb" && !loadingUpdate) {
      cleanData();
    }
  }, [deleteConfig]);

  useEffect(() => {
    if (setConfig === "Success" && query.get("conf") === "tapweb" && !loadingUpdate) {
      cleanData();
    }
  }, [setConfig]);

  useEffect(() => {
    if (query.get("conf") === "tapweb") {
      if (getConfig) {
        const configData = getConfig.config[confTmp];
        if (configData) {
          const tapInt = tapInterfaces.filter((ti) => ti.value === configData.interface)[0];
          setSelectedTapInterface(tapInt);
        }
      }
    }
  }, [getConfig, confTmp, tapInterfaces]);

  const isDuplicate = () => {
    const config = getConfig.config;
    if (config && config?.some((cfg) => cfg.interface === selectedTapInterface.value)) {
      dispatch(
        addNotification({
          message: "Interface already exists",
          options: { variant: "error" },
        }),
      );
      return true;
    }
    return false;
  };

  const addConfig = () => {
    if (!selectedTapInterface) return;
    if (isDuplicate()) return;

    const config = {
      bulk: 16,
      type: "tapzeek",
      interface: selectedTapInterface.value,
      interval: 5,
    };
    const configString = JSON.stringify(config);
    const data = { appname: "tapweb", config: configString };
    dispatch(RequestSetConfig(data));
  };

  const updateConfigData = () => {
    if (!selectedTapInterface) return;
    if (isDuplicate()) return;

    const config = {
      bulk: 16,
      type: "tapzeek",
      interface: selectedTapInterface.value,
      interval: 5,
    };
    const configString = JSON.stringify(config);
    const data = {
      appname: "tapweb",
      config: configString,
      mountpoint: getConfig.config?.[query.get("t")]?.interface,
    };
    dispatch(RequestUpdateConfig(data));
  };

  const delConfig = () => {
    dispatch(
      RequestDeleteConfig({
        inttype: "tapweb",
        mountpoint: getConfig.config?.[query.get("t")]?.interface,
      }),
    );
  };

  return show ? (
    <IntegrationMarketModal
      title="Tap Interface"
      onBack={() => history.push("/integration-market?bck=" + query.get("conf"))}
      onClose={closePopupHandler}>
      <div className="tapweb-settings">
        <p className="settings__label">Select interface</p>
        <CustomSelect
          data={tapInterfaces.length ? tapInterfaces : []}
          select={selectedTapInterface}
          setSelected={setSelectedTapInterface}
          width={220}
          disabled={tapInterfaces.length === 0}
          placeholder={tapInterfacesLoading ? "Fetching data..." : "No data."}
        />
      </div>

      <div className="integration-market-modal__action">
        {confType ? (
          <button onClick={addConfig} className="primary-button">
            Add Config
          </button>
        ) : (
          <>
            <button onClick={updateConfigData} className="primary-button">
              Update
            </button>
            <button onClick={delConfig} className="danger-button">
              Delete
            </button>
          </>
        )}
      </div>

      {(loading || loadingUpdate) && query.get("conf") === "tapweb" && (
        <Backdrop absolute={true} show={loading || loadingUpdate} message="Please wait..." />
      )}
    </IntegrationMarketModal>
  ) : null;
};

export default TapInterfaceSettings;
